import React from "react";
import styled from "@emotion/styled";
import { useTheme } from "@emotion/react";
import Image from "@components/item/Image";
import useFilterStepStore from "@store/CategoryFilter/useFilterStepStore";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Container = styled.div({
  width: "100%",
  height: "calc(100vh - 8rem)",
  backgroundColor: "white",
  position: "relative",
});

const Header = styled.div({
  padding: "2rem",
  display: "flex",
});

const Title = styled.h1({
  fontSize: "1.8rem",
  fontWeight: "500",
  textAlign: "center",
  flexGrow: 1,
});

const FilterButton = styled.button(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  padding: "2rem",
  borderBottom: `1px solid ${theme.color.border_gray}`,
  fontSize: "1.6rem",
}));

const Name = styled.span({
  textAlign: "end",
  flex: 1,
  marginRight: "1rem",
});

const ResetButton = styled.button(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "end",
  padding: "2rem",
  gap: "1rem",
  fontSize: "1.6rem",
  position: "absolute",
  bottom: 0,
  color: theme.color.light_gray,
}));

const CategoryFilterSection = () => {
  const theme = useTheme();
  const { setStep } = useFilterStepStore();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  // URL에서 정렬 이름 직접 가져오기
  const sortName = searchParams.get("sort_name");
  const conditionName = searchParams.get("product_condition_name");
  const colorName = searchParams.get("color_name");
  const isFreeShipping = searchParams.get("is_free_shipping");
  const brandName = searchParams.get("brand_name");
  const categoryId = searchParams.get("category_id");
  const categoryName = searchParams.get("categoryName");
  const { t } = useTranslation();

  const resetFilters = () => {
    navigate(
      "/search/category?category_id=" +
        categoryId +
        "&categoryName=" +
        categoryName,
    );
  };

  return (
    <Container>
      <Header>
        <Title>{t("필터")}</Title>

        <button onClick={() => setStep(0)}>
          <Image src={theme.image.close.default} />
        </button>
      </Header>

      <div>
        <FilterButton onClick={() => setStep(2)}>
          <span>{t("정렬")}</span>
          <Name>{sortName}</Name>

          <Image src={theme.image.arrow_right.default} />
        </FilterButton>

        <FilterButton onClick={() => setStep(3)}>
          <span>{t("브랜드")}</span>
          <Name>{brandName}</Name>

          <Image src={theme.image.arrow_right.default} />
        </FilterButton>

        <FilterButton onClick={() => setStep(4)}>
          <span>{t("컨디션")}</span>
          <Name>{conditionName}</Name>

          <Image src={theme.image.arrow_right.default} />
        </FilterButton>

        <FilterButton onClick={() => setStep(5)}>
          <span>{t("컬러")}</span>
          <Name>{colorName}</Name>

          <Image src={theme.image.arrow_right.default} />
        </FilterButton>

        <FilterButton onClick={() => setStep(6)}>
          <span>{t("무료배송")}</span>
          <Name>{isFreeShipping === "1" ? "O" : ""}</Name>
          <Image src={theme.image.arrow_right.default} />
        </FilterButton>
      </div>

      <ResetButton onClick={resetFilters}>
        <Image src={theme.image.reset_icon.default} />
        {t("필터 초기화")}
      </ResetButton>
    </Container>
  );
};

export default CategoryFilterSection;
